import React, { useCallback, useContext, useState } from 'react';
import styled, { css } from 'styled-components';
import { useAddressSelectionData } from '../../useAddressSelectionData';
import { LoadingIconCoupon } from '../../../loading/LoadingIconCoupon';
import { ModalContext } from '../../../modal';
import { colors } from '../../../../theme/color';
import { OrderType } from '../../../../types';
import { useRestaurantSelected } from '../../../../state/order/hooks/useOrderMutation';
import { storage } from '../../../../utils/storage';
import { Primary as PrimaryButton } from '../../../button';
import { AddressSelectionContext } from '../../AddressSelectionProvider';
import { canSelectionProceed } from './helpers';
import {
  AnalyticsEcommercePromotion,
  AnalyticsPromotionName,
  analyticsEvents,
} from '../../../../utils/analytics/analytics';

export const RestaurantConfirmedButton: React.FC<{ disabled: boolean }> = ({ disabled }) => {
  const { orderType, searchQuery, isHomepage, onRestaurantSelected } =
    useContext(AddressSelectionContext);
  const { closeModal, isOpen } = useContext(ModalContext);
  const [loading, setLoading] = useState<boolean>(false);

  const selectRestaurant = useRestaurantSelected();
  const data = useAddressSelectionData();

  const handleClick = useCallback(async () => {
    try {
      setLoading(true);
      await selectRestaurant(data);

      // close modal that contains address selection
      if (isOpen()) {
        closeModal();
      }

      if (orderType === OrderType.DELIVERY) {
        storage.removeItem('pickup_search_query');
      } else {
        storage.setItem('pickup_search_query', searchQuery);
      }

      if (onRestaurantSelected) {
        onRestaurantSelected(data);
        analyticsEvents.selectPromotion({
          promotion_name: AnalyticsPromotionName.RestaurantSelection,
          creative_name: data.restaurant?.displayName || '',
          creative_slot: '',
          delivery_time:
            data.type === OrderType.DELIVERY
              ? data.restaurant?.currentDeliveryEstimate
              : data.restaurant?.currentPickupEstimate,
          delivery_price: data.restaurant?.dynamicDeliveryFee || data.restaurant?.deliveryFee || 0,
          delivery_type: orderType,
        } as AnalyticsEcommercePromotion);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      throw e;
    }
  }, [closeModal, data, isOpen, onRestaurantSelected, orderType, searchQuery, selectRestaurant]);

  return (
    <Container>
      <ConfirmButton disabled={disabled || !canSelectionProceed(data)} onClick={handleClick}>
        {loading ? (
          <LoadingIconCoupon color={colors.white} />
        ) : isHomepage ? (
          'Siirry ostoksille'
        ) : (
          'Tallenna valinnat'
        )}
      </ConfirmButton>
    </Container>
  );
};

const Container = styled.div`
  padding: 0 24px 16px 24px;
`;

const ConfirmButton = styled(PrimaryButton)<{ disabled: boolean }>(
  ({ disabled }) => css`
    max-width: 105%;
    width: calc(100% + 16px);
    margin-left: -8px;
    margin-top: 10px;
    display: none;
    margin-bottom: 0;

    ${!disabled && `display: inline-block;`}
  `
);
